var map = {
	"./camp_store.svg": 4568,
	"./camper_station.svg": 6998,
	"./caravan_salon.svg": 2739,
	"./laundry.svg": 3492,
	"./lpg.svg": 588,
	"./service.svg": 8742,
	"./shower.svg": 3959,
	"./water.svg": 4610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;